import { render, staticRenderFns } from "./InvitationalEvents.vue?vue&type=template&id=3ffa19dc"
import script from "./InvitationalEvents.vue?vue&type=script&lang=js"
export * from "./InvitationalEvents.vue?vue&type=script&lang=js"
import style0 from "./InvitationalEvents.vue?vue&type=style&index=0&id=3ffa19dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports